import { Alert, Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Snackbar } from '@mui/material';
import styles from './index.module.css'
import { useFormik } from 'formik';
import 'react-phone-number-input/style.css'
import './phoneInputOverride.css'
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input'
import { useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash';
// import Input from 'react-phone-number-input/input'
// import { isPossiblePhoneNumber } from 'react-phone-number-input';
import { defaultFormState, selectValues, webDevSelectValues } from '../../../../utils/helpers';
import { FormHelperTextWrapper, FormSchema, TextInput } from './FormComponents';

const Form = ({
	onSubmitCallback
}) => {

	const [snackState, setSnackState] = useState({
		open: false,
		message: '',
		severity: ''
	})

	const handleClose = () => {
		setSnackState({
			open: false,
			message: '',
			severity: ''
		})
	}

	useEffect(() => {

		if (snackState.open) {
			setTimeout(() => {
				handleClose()
			}, 6000);
		}
	}, [snackState])

	const formik = useFormik({
		initialValues: { ...defaultFormState },
		validationSchema: FormSchema,
		onSubmit: values => {
			// alert(JSON.stringify(values, null, 2));

			if (Object.keys(values).every(item => {
				return isEmpty(values[item])
			})) {
				setSnackState({
					open: true,
					message: 'Please fll the form',
					severity: 'error'
				})
			} else {
				onSubmitCallback()
			}
		},
	});

	return (
		<Box className={`h-full`}>
			<Snackbar
				open={snackState.open}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				autoHideDuration={6000}
				onClose={handleClose}
			>
				<Alert
					onClose={handleClose}
					severity={snackState.severity}
					variant="filled"
					sx={{ width: '100%' }}
				>
					{snackState.message}
				</Alert>
			</Snackbar>

			<form onSubmit={formik.handleSubmit} className={`${styles['form-fields']} flex flex-col gap-y-1 h-full`}>
				<FormControl className={`${styles['field-wrapper']}`}>
					<TextInput
						name="name"
						label="Full Name"
						value={formik.values.name}
						onChange={e => formik.setFieldValue('name', e.target.value)}
						error={formik.errors.name}
						helperText={formik.errors.name}
					/>
				</FormControl>

				<Grid container justifyContent={'space-between'} className={`${styles['field-wrapper']} ${styles['mail-phone']} justify-between`}>
					<Grid item xs={12} md={6} className={`${styles['phone-grid-item']}`}>
						<FormControl className={`${styles['form-control']} w-full`}>
							<TextInput
								name="phone"
								label="Phone"
								value={formik.values.phone}
								className={`${styles['text-field']} w-full`}
								onChange={e => {
									formik.setFieldValue('phone', e.target.value)
								}}
								error={formik.errors.phone}
								helperText={formik.errors.phone}
							/>
						</FormControl>
					</Grid>
					<Grid item md={6} xs={12}>
						<FormControl className={`${styles['form-control']}`}>
							<TextInput
								name="email"
								label="Email"
								className={`${styles['text-field']}`}
								value={formik.values.email}
								onChange={e => formik.setFieldValue('email', e.target.value)}
								error={formik.errors.email}
								helperText={formik.errors.email}
							/>
						</FormControl>
					</Grid>
				</Grid>

				<FormControl className={`${styles['field-wrapper']}`}>
					<TextInput label="Organisation Name" className={`${styles['text-field']}`}
						value={formik.values.org}
						onChange={e => formik.setFieldValue('org', e.target.value)}
					/>
				</FormControl>

				<FormControl className={`${styles['field-wrapper']} ${styles['field-select']}`} size="small" variant="standard"
					error={formik.errors.interest}
					sx={{
						'& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused[data-shrink="true"]': {
							color: 'var(--bg-blue)'
						},
						'& .MuiInputBase-root::after': {
							borderColor: 'var(--bg-blue)'
						},
					}}
				>
					<InputLabel id="demo-simple-select-label">
						Area of interest
					</InputLabel>
					<Select
						name={'interest'}
						labelId="demo-simple-select-label"
						id="named-select"
						label="Area of interest"
						error={formik.errors.interest}
						value={formik.values.interest}
						onChange={e => formik.setFieldValue('interest', e.target.value)}
						inputProps={{
							'::placeholder': {
								color: 'red'
							}
						}}
					>
						<MenuItem value="">
							<em>--select--</em>
						</MenuItem>
						{
							webDevSelectValues.map((item, index) => {

								return <MenuItem key={index} value={item.value}>{item.label}</MenuItem >
							})
						}
						{
							selectValues.map((item, index) => {
								return <MenuItem key={index} value={item.value}>{item.label}</MenuItem >
							})
						}
					</Select>
					<FormHelperTextWrapper formik={formik} name={'interest'} />
				</FormControl>

				<FormControl className={`${styles['field-wrapper']}`}>
					<TextInput
						label="Message"
						multiline
						value={formik.values.message}
						onChange={e => formik.setFieldValue('message', e.target.value)}
						minRows={2}
						maxRows={4}
						error={formik.errors.message}
						helperText={formik.errors.message}
					/>
				</FormControl>

				<Box className={`flex items-end w-full h-full`}>
					<Button
						className={`w-full`}
						type='submit'
						variant="contained"
						sx={{
							backgroundColor: 'var(--bg-blue)',
							boxShadow: 'none',
							':hover': {
								backgroundColor: 'var(--bg-blue-dark)'
							}
						}}
					>Submit</Button>
				</Box>
			</form>
		</Box>
	);
}

export default Form;